import React from 'react';
import { Eye, Microscope, ShieldCheck } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const OphthalmologyPage = () => {
  const config = {
    badge: "Ophthalmology Unit",
    headline: "Vision &",
    headlineItalic: "Eye Mastery.",
    subtext: "Preserving sight and ocular health through precision diagnostics, surgical excellence, and compassionate clinical care.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Veterinary Ophthalmology at Dr. Suresh Pet Care — Eye Care Excellence",
    stats: [
      { value: 600, suffix: '+', label: 'Eye Cases Treated' },
      { value: 97, suffix: '%', label: 'Vision Preservation Rate' },
      { value: 5, suffix: '+', label: 'Years Expertise' },
      { value: 24, suffix: '/7', label: 'Emergency Care' },
    ],
    services: [
      {
        title: "Ocular Diagnostics",
        icon: <Eye size={28} />,
        desc: "Comprehensive slit-lamp examination, tonometry, and fundoscopy to assess all layers of ocular health.",
        specs: ["Slit Lamp Exam", "Intraocular Pressure", "Fundoscopy", "Schirmer Tear Test"],
        color: "from-indigo-500/10 to-primary/10"
      },
      {
        title: "Cataract Surgery",
        icon: <ShieldCheck size={28} />,
        desc: "Phacoemulsification cataract surgery to restore vision with precision and minimal recovery time.",
        specs: ["Phacoemulsification", "Intraocular Lens", "Pre-op Screening", "Vision Recovery"],
        color: "from-primary/10 to-blue-500/10"
      },
      {
        title: "Corneal Conditions",
        icon: <Microscope size={28} />,
        desc: "Diagnosis and management of corneal ulcers, keratitis, and other complex ocular surface diseases.",
        specs: ["Corneal Cytology", "Fluorescein Staining", "Topical Management", "Keratotomy"],
        color: "from-violet-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Ophthalmic",
    sectionItalic: "Services.",
    warningTitle: "Eye Health",
    warningItalic: "Warning Signs.",
    warningText: "Ocular conditions can rapidly deteriorate without prompt attention. Early intervention preserves vision and prevents chronic damage.",
    warnings: [
      { name: "Cloudy Eyes", desc: "Bluish or white cloudiness may indicate cataracts or corneal disease.", icon: "👁️" },
      { name: "Excessive Tearing", desc: "Overflow of tears may signal blocked ducts, eye irritation, or infection.", icon: "💧" },
      { name: "Squinting or Pawing", desc: "Consistent squinting or face-pawing is a sign of ocular discomfort.", icon: "😣" },
      { name: "Redness & Swelling", desc: "Red, swollen eyes may indicate conjunctivitis, uveitis, or glaucoma.", icon: "🔴" },
    ],
    ctaBadge: "Ophthalmology Unit",
    ctaTitle: "The Eye Care",
    ctaItalic: "Expertise.",
    ctaText: "Our ophthalmology unit brings surgical precision and diagnostic clarity to preserve and protect your pet's vision in Hyderabad.",
    ctaBtn: "Book Eye Consultation",
    seoText: "Advanced veterinary eye care in Hyderabad. Cataract surgery and ocular diagnostics for dogs and cats at Dr. Suresh Pet Care. Precision ophthalmology services.",
    glowColor: "indigo-500"
  };

  return (
    <>
      <SEO 
        title="Veterinary Ophthalmology & Eye Care"
        description="Advanced eye care, cataract surgery, and ocular diagnostics for pets at Dr. Suresh Pet Care in Hyderabad."
        canonical="/ophthalmology"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default OphthalmologyPage;
